import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    FETCH_BRANDS
    FETCH_BRANDS_SUCCESS
    FETCH_BRANDS_FAILURE

    FETCH_MODELS
    FETCH_MODELS_SUCCESS
    FETCH_MODELS_FAILURE

    FETCH_YEAR
    FETCH_YEAR_SUCCESS
    FETCH_YEAR_FAILURE

    FETCH_VARIANTS
    FETCH_VARIANTS_SUCCESS
    FETCH_VARIANTS_FAILURE

    FETCH_STATES
    FETCH_STATES_SUCCESS
    FETCH_STATES_FAILURE

    RESET_SELECTIONS
    RESET_SPECIFIED_KEY

    UPDATE_SELECTED_BRAND
    UPDATE_SELECTED_MODEL
    UPDATE_SELECTED_YEAR
    UPDATE_SELECTED_VARIANT
    UPDATE_SELECTED_STATE

    MAKE_LEAD_SUCCESS
    MAKE_LEAD_FAILURE

    FETCH_BRANCH_COUNT_SUCCESS
    FETCH_BRANCH_COUNT_FAILURE
`,
    {
        prefix: "legacyform/"
    }
);
